﻿import { Experiment, FeaturesApi } from './FeaturesApi'

export class MockFeaturesApi implements FeaturesApi {
  async getExperiment(experimentName: string): Promise<Experiment | null> {
    return null
  }

  async getFeatureFlag(flagName: string): Promise<boolean> {
    return Promise.resolve(false)
  }

  getFeatureGate(gateName: string): Promise<boolean> {
    return Promise.resolve(false)
  }
}
